import {Box, TablePagination} from "@mui/material"
import {useFormik} from "formik"
import React, {useEffect} from "react"
import AppointmentList from "../components/appointment/AppointmentList"
import CustomDatePicker from "../components/common/CustomDatePicker"
import CustomSearch from "../components/common/CustomSearch"
import SearchComponent from "../components/searchComponent/SearchComponent"
import {useAppDispatch, useTypedSelector} from "../store"
import {
    clearQueryAppointmentFilterData,
    clearQueryAppointmentQuery,
    setAppointmentFilterData,
} from "../store/appointment/appointment.slice"
import {IGetAppointmentFilter} from "../store/rtk-api/appointment/types"
import {setFilterData} from "../store/doctors/doctors.slice";

const Appointment = () => {
    const dispatch = useAppDispatch()

    // Filter actions
    const {query, visit_date} = useTypedSelector((state) => state.appointment)
    const formik = useFormik<IGetAppointmentFilter>({
        enableReinitialize: true,
        initialValues: {
            query: query || "",
            visit_date: visit_date || "all",
        },

        onSubmit: (values) => {
            dispatch(setAppointmentFilterData({page: undefined, query: values.query, visit_date: values.visit_date}))
        }
    })
    const [page, setPage] = React.useState(0)
    useEffect(() => {
        dispatch(setAppointmentFilterData({page: page + 1}))
        dispatch(clearQueryAppointmentQuery())
    }, [page])

    const {handleChange, values, handleSubmit, setFieldValue} = formik
    const handleClear = () => {
        dispatch(clearQueryAppointmentFilterData())
        setFieldValue('query', '')
    }

    // Pagination actions

    const [rowsPerPage, setRowsPerPage] = React.useState(20)
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage)
    }
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 20))
        setPage(0)
    }
    const {appointmentCount} = useTypedSelector(state => state.calendar)

    const children = (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <div style={{marginRight: "20px"}}>
                    <CustomSearch
                        field={"query"}
                        handleChange={handleChange}
                        placeholder={"Врач, услуга, процедура"}
                        width={"300px"}
                        name={"query"}
                        values={values}
                        handleSubmit={handleSubmit}
                        handleClear={handleClear}
                    />
                </div>
                <div style={{display: "flex", alignItems: "center", gap: "2px"}}>
                    Дата:{" "}
                    <CustomDatePicker
                        handleSubmit={handleSubmit}
                        field={"visit_date"}
                        setFieldValue={setFieldValue}
                    />
                </div>
            </div>

            <div>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={
                        appointmentCount ||
                        0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage=""
                    sx={{marginBottom: "10px"}}
                />
            </div>
        </Box>
    )

    return (
        <>
            <SearchComponent children={children}/>
            <AppointmentList rowsPerPage={rowsPerPage}/>
        </>
    )
}

export default Appointment
